/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Flagsbyflagpedia2Inputs */

const id_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bendera oleh Flagpedia`)
};

const ms_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bendera oleh Flagpedia`)
};

const da_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flag fra Flagpedia`)
};

const de_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flaggen von Flagpedia`)
};

const en_us2_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flags by Flagpedia`)
};

const es_es2_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banderas de Flagpedia`)
};

const es_mx2_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banderas de Flagpedia`)
};

const fil_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Watawat mula sa Flagpedia`)
};

const fr_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drapeaux par Flagpedia`)
};

const it_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandiere di Flagpedia`)
};

const hu_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zászlók a Flagpedia-től`)
};

const nl_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlaggen van Flagpedia`)
};

const no_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagg fra Flagpedia`)
};

const pl_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagi z Flagpedia`)
};

const pt_br2_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandeiras por Flagpedia`)
};

const pt_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bandeiras por Flagpedia`)
};

const ro_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steaguri de la Flagpedia`)
};

const fi_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liput Flagpediasta`)
};

const sv_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flaggor från Flagpedia`)
};

const vi_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cờ bởi Flagpedia`)
};

const tr_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagpedia'dan Bayraklar`)
};

const cs_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlajky od Flagpedia`)
};

const bg_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Знамена от Flagpedia`)
};

const ru_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Флаги от Flagpedia`)
};

const uk_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прапори від Flagpedia`)
};

const ar_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأعلام من Flagpedia`)
};

const hi_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagpedia द्वारा झंडे`)
};

const th_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ธงโดย Flagpedia`)
};

const ja_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagpedia による旗`)
};

const zh_cn2_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旗帜图标来自 Flagpedia`)
};

const zh_hant1_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`旗幟圖示來自 Flagpedia`)
};

const ko_footer_flagsbyflagpedia2 = /** @type {(inputs: Footer_Flagsbyflagpedia2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flagpedia 제공 국기`)
};

/**
* | output |
* | --- |
* | "Flags by Flagpedia" |
*
* @param {Footer_Flagsbyflagpedia2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const footer_flagsbyflagpedia2 = /** @type {((inputs?: Footer_Flagsbyflagpedia2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Flagsbyflagpedia2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_footer_flagsbyflagpedia2(inputs)
	if (locale === "ms") return ms_footer_flagsbyflagpedia2(inputs)
	if (locale === "da") return da_footer_flagsbyflagpedia2(inputs)
	if (locale === "de") return de_footer_flagsbyflagpedia2(inputs)
	if (locale === "en-US") return en_us2_footer_flagsbyflagpedia2(inputs)
	if (locale === "es-ES") return es_es2_footer_flagsbyflagpedia2(inputs)
	if (locale === "es-MX") return es_mx2_footer_flagsbyflagpedia2(inputs)
	if (locale === "fil") return fil_footer_flagsbyflagpedia2(inputs)
	if (locale === "fr") return fr_footer_flagsbyflagpedia2(inputs)
	if (locale === "it") return it_footer_flagsbyflagpedia2(inputs)
	if (locale === "hu") return hu_footer_flagsbyflagpedia2(inputs)
	if (locale === "nl") return nl_footer_flagsbyflagpedia2(inputs)
	if (locale === "no") return no_footer_flagsbyflagpedia2(inputs)
	if (locale === "pl") return pl_footer_flagsbyflagpedia2(inputs)
	if (locale === "pt-BR") return pt_br2_footer_flagsbyflagpedia2(inputs)
	if (locale === "pt") return pt_footer_flagsbyflagpedia2(inputs)
	if (locale === "ro") return ro_footer_flagsbyflagpedia2(inputs)
	if (locale === "fi") return fi_footer_flagsbyflagpedia2(inputs)
	if (locale === "sv") return sv_footer_flagsbyflagpedia2(inputs)
	if (locale === "vi") return vi_footer_flagsbyflagpedia2(inputs)
	if (locale === "tr") return tr_footer_flagsbyflagpedia2(inputs)
	if (locale === "cs") return cs_footer_flagsbyflagpedia2(inputs)
	if (locale === "bg") return bg_footer_flagsbyflagpedia2(inputs)
	if (locale === "ru") return ru_footer_flagsbyflagpedia2(inputs)
	if (locale === "uk") return uk_footer_flagsbyflagpedia2(inputs)
	if (locale === "ar") return ar_footer_flagsbyflagpedia2(inputs)
	if (locale === "hi") return hi_footer_flagsbyflagpedia2(inputs)
	if (locale === "th") return th_footer_flagsbyflagpedia2(inputs)
	if (locale === "ja") return ja_footer_flagsbyflagpedia2(inputs)
	if (locale === "zh-CN") return zh_cn2_footer_flagsbyflagpedia2(inputs)
	if (locale === "zh-Hant") return zh_hant1_footer_flagsbyflagpedia2(inputs)
	return ko_footer_flagsbyflagpedia2(inputs)
});
export { footer_flagsbyflagpedia2 as "footer.flagsByFlagpedia" }